<template>
  <div class="modal">
    <div class="empty" @click="$emit('close')"></div>
    <div class="box">
      <div class="content">
        <form @submit.prevent="setFor">
          <span class="title">Recuperar conta</span>
          <div class="avatar">
            <div class="white"></div>
          </div>
          <span class="code">Para recuperar sua conta, entre em contato com a equipe da rádio pelo Discord.</span>
          <span class="code small">A recuperação automática de senha volta em breve.</span>
          <button>Entendi</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>


import { useStore } from '@/stores/index.js'

const store = useStore()

async function setFor() {
  store.Alert('Entre em contato com a equipe da rádio pelo Discord. A recuperação automática volta em breve.')
}

</script>

<style scoped>

.box {
  width: 300px !important;
  background-color: rgb(236, 241, 235) !important;
  border-radius: 20px !important;
}

.content form {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}


.content form .title {
  width: 100%;
  height: 30px;
  font-size: 20px;
  font-weight: 800;
  text-align: center;
  margin-top: 10px;
  background: -webkit-linear-gradient(#0D93C6, #35B6FF);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.content form .avatar {
  width: 100%;
  height: 140px;
  background: url('@/assets/user.png') no-repeat center 5px;
  margin-top: 30px;
}

.content form .avatar .white {
  width: 100%;
  height: calc(100% + 1px);
  background: rgb(255, 255, 255);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgb(236, 241, 235) 100%);
}

.content form input {
  width: 250px;
  background-color: #fff;
  border-radius: 40px;
  text-align: center;
}

.content form .code {
  width: 250px;
  font-size: 14px;
  margin-top: 10px;
  font-weight: 500;
  text-align: center;
}

.content form .code.small {
  font-size: 12px;
  color: #667085;
}

.content form .code span {
  font-weight: 600;
  color: #2EC044;
}

.content form button {
  width: 250px;
  height: 46px;
  padding: 0 20px;
  color: #fff;
  font-size: 14px;
  text-align: center;
  line-height: 46px;
  font-weight: 700;
  border-radius: 40px;
  background: #35B6FF;
  background: linear-gradient(90deg, #0D93C6 0%, #35B6FF 100%);
  margin: 10px 0 0 0;
  transform: none;
}
</style>
